import React, { Component } from 'react';
import styled from 'styled-components';
import { isMobile, validateUrl, getParameterByName } from '../Helpers';
// import AsyncComponent from '../AsyncComponent';

// const VideoChat = AsyncComponent(() => import('../../../pages/common/VideoChat/container'));

const Wrapper = styled.div`
  display: block;
  position: relative;
  text-align: right;
  z-index: 0;
  width: ${(props) => (props.videoChatEnabled ? '290px' : props.type === 'tablet' ? '25px' : '')};
  right: 0;
  margin-top: ${(props) => (props.isGridwall && !props.isExpressCheckout ? '80px' : '3px')};
  top: ${(props) => (props.type === 'tablet' ? '50px' : '')};
  .c2c_container_desktop {
    margin-top: -12px;
  }
`;

class ChatAndC2C extends Component {
  componentDidMount() {
    const pageIdProperty = validateUrl(window.location.pathname + window.location.hash.split('?')[0]);
    setTimeout(() => {
      if (window.PageIds !== null && window.PageIds !== undefined) {
        window.inqSiteId = validateUrl(window.PageIds[pageIdProperty]);
        if (window.inqSiteId && window.Inq && window.Inq.reinitChat) {
          try {
            window.Inq.reinitChat(validateUrl(window.inqSiteId));
          } catch (err) {
            console.log('Error in class ChatAndC2C', err);
          }
        }
      }
      if (window.c2c !== null && window.c2c !== undefined) {
        try {
          window.c2c.initializeC2C([
            {
              buttonname: 'generic-c2c-container-desktop',
              targeteddiv: ['c2c_container_desktop'],
              url: '/content/vzw-engage/c2c/btn.display.generic-c2c-container-desktop.html',
            },
          ]);
        } catch (err) {
          console.log('Error in class ChatAndC2C', err);
        }
      }
    }, 2000);
  }

  render = () => {
    const enableC2C = true;
    return (
      <div className="textAlignRight positionRelative displayInlineFlex skipPrint" id="chatCall">
        {!isMobile() && (
          <Wrapper id="c2c_wrapper_desktop" isExpressCheckout={getParameterByName('compatibledevice') && getParameterByName('expresscheckout')}>
            <div id="inqC2CImgContainer_Fixed1" className="displayInlineFlex" />
            {/* <div id="nuance-chat-container-1" className="displayInlineFlex" /> -commited because chat icon showing twice-*/}
            {/* {enableC2C && <div id="c2c-container-5g-desktop" className="c2c-container-5g-desktop" />} */}
          </Wrapper>
        )}
        {isMobile() && enableC2C && <div className="c2c_container_mobile" />}
      </div>
    );
  };
}

export default ChatAndC2C;
